import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {NbButtonModule, NbCardModule, NbRadioModule, NbWindowRef} from '@nebular/theme';
import {MasterCardSaveOption} from '../../../../../admin-shared/interfaces/MasterCardSaveOption';
import {translations} from '../../../../../../environments/translations.ru';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-modal-master-card-save',
  templateUrl: './modal-master-card-save.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NbCardModule, NbRadioModule, NbButtonModule, FormsModule]
})
export class ModalMasterCardSaveComponent implements OnInit {
  @Input()
  enabledSaveOptions: Set<MasterCardSaveOption> = new Set([
    MasterCardSaveOption.EDIT_ONLY_IN_MASTER_CARD,
    MasterCardSaveOption.ADD,
    MasterCardSaveOption.ADD_AND_DELETE,
    MasterCardSaveOption.REPLACE_MEDIA
  ]);

  masterCardSaveOptions = [
    {
      value: MasterCardSaveOption.EDIT_ONLY_IN_MASTER_CARD,
      label: translations.masterCardSaveOptions.editOnlyInMasterCard
    },
    {
      value: MasterCardSaveOption.ADD,
      label: translations.masterCardSaveOptions.add,
    },
    {
      value: MasterCardSaveOption.ADD_AND_DELETE,
      label: translations.masterCardSaveOptions.addAndDelete
    },
    {
      value: MasterCardSaveOption.REPLACE_MEDIA,
      label: translations.masterCardSaveOptions.replaceMedia
    }
  ];

  masterCardSaveOption = MasterCardSaveOption.EDIT_ONLY_IN_MASTER_CARD;

  constructor(protected ref: NbWindowRef<ModalMasterCardSaveComponent>) {
  }

  ngOnInit(): void {
    this.masterCardSaveOptions = this.masterCardSaveOptions.filter(
      masterCardSaveOption => this.enabledSaveOptions.has(masterCardSaveOption.value)
    );
  }

  dismiss(masterCardSaveOption: MasterCardSaveOption) {
    this.ref.close(masterCardSaveOption);
  }
}
